import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { HOVER } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingUploadButtonHovered = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		name: 'dlr_mrktplace_bulk_bidding_upload_button_hovered',
		schemaName: HOVER.SCHEMA,
		version: HOVER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
